import { Component, OnInit, OnDestroy, Optional, Injectable, ChangeDetectorRef } from '@angular/core'
import { GSBaseControl } from './gs.base.control';
import { Item } from '../entity/entities';
import { FormPhoneNumberProperty } from '../entity/form/formPhoneNumber.property';

@Component({
  selector: 'gs-phone-number',
  templateUrl: './gs.phoneNumber.control.html'
})
@Injectable()
export class GSPhoneNumberControl extends GSBaseControl implements OnInit, OnDestroy {
  //#region -------Properties
  public stringItem = { value: '' };
  //#endregion

  //#region -------Constructor
  constructor(@Optional() prop: FormPhoneNumberProperty, @Optional() item: Item, private changeDr: ChangeDetectorRef) {
    super(changeDr);
        this.property = prop;
        this.item = item;
    }
  //#endregion

  //#region -------NG Events
  ngOnInit() {

    if (this.item && this.item.onRevertData) {
      this.item.onRevertData.subscribe(() => {
        this.updateDisplayValue();
      }, this);
    }
    if (this.item && this.item.onSetData) {  
      this.item.onSetData.subscribe(() => {
        this.updateDisplayValue();
      }, this);
    }
  }

  ngOnDestroy() {
    if (this.item) {
      this.item.unsubscribeSubscriber(this);
    }
  }
  //#endregion

  //#region -------UI Events
  change(e) {
    if (e || e == '') {
      let previousValue = this.data[this.name];

      let len = e.replaceAll('(', '').replaceAll(')', '').replaceAll(' ', '').replaceAll('-', '').length;

      if (len > 10)
        e = e.substr(0, e.length - (len - 10));

      //this.value = e;
      this.item.reCheckDirty();
      this.onChange.emit({ propertyName: this.name, previousValue: previousValue, newValue: this.value, event: e, item: this.item, property: this.property });
      this.property.changed.emit({ propertyName: this.name, previousValue: previousValue, newValue: this.value, event: e, item: this.item, property: this.property });
    }
  }

  keydown(e) {
    if (e.code == 'Backspace' && this.value.length <= 2) {
      this.change('');
    }
    this.property.keydown.emit({ propertyName: this.name, event: e });
  }

  onpaste(e) {
    this.property.onpaste.emit({ propertyName: this.name, event: e });
  }
  //#endregion

  //#region -------Private Methods
  private updateDisplayValue() {
    if (this.data && this.name) {
      let rawValue = this.data[this.name] || '';
      let formattedValue = this.formatPhoneNumber(rawValue.toString());
      this.stringItem.value = formattedValue; 

      this.changeDr.detectChanges();
    }
  }

  private formatPhoneNumber(value: string): string {
    if (!value) return '';
    
    let newVal = value.replace(/\D/g, '');
    if (newVal.length === 0) {
      return '';
    } else if (newVal.length <= 3) {
      return newVal.replace(/^(\d{0,3})/, '($1)');
    } else if (newVal.length <= 6) {
      return newVal.replace(/^(\d{0,3})(\d{0,3})/, '($1) $2');
    } else if (newVal.length <= 10) {
      return newVal.replace(/^(\d{0,3})(\d{0,3})(\d{0,4})/, '($1) $2-$3');
    } else {
      newVal = newVal.substring(0, 10);
      return newVal.replace(/^(\d{0,3})(\d{0,3})(\d{0,4})/, '($1) $2-$3');
    }
  }
  //#endregion
}